import * as React from 'react';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import cx from 'classnames';

import './styles/FormSingle.scss';

/**
 * ## An [Input](/internal/components/Input) with an attached [Button](/internal/components/Button).
 * ### Used for simple, single-field forms.
 *
 * ```example
 * <FormSingle>
 *   <Input placeholder="Input" />
 *   <Button>Button</Button>
 * </FormSingle>
 * ```
 *
 * ```example
 * <FormSingle reset="mobile">
 *   <Input placeholder="Input" />
 *   <Button>Button</Button>
 * </FormSingle>
 * ```
 */

type Props = {
  children: [React.ReactNode, React.ReactNode];
  reset?: 'mobile';
  className?: string;
};

class FormSingle extends React.Component<Props> {
  static propClasses = {
    reset: {
      mobile: 'FormSingle--reset--mobile',
    },
  };

  render() {
    const { children, className } = this.props;

    return (
      <div className={cx('FormSingle', className, getPropClassesFromInstance(this))}>
        {children}
      </div>
    );
  }
}

export default FormSingle;
